import React from 'react';
import { ClassAssembly8B2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly8B2026/>;
  };
  
  export default ClassAssemblyPage;